<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4 style="margin-top: 10px;">病例详情</h4>
      <el-button
        size="small"
        type="info"
        @click="backProject"
      >返回</el-button>
    </div>
    <!-- 这里边是一个表单 -->
    <el-card class="box-card">
      <div class="content">
        <h4>{{Details.title}}</h4>
        <p class="p">
          <span>{{Details.create_time}}</span>
          <span style="margin: 0 50px;"> 作者：
            <span v-if="Details.author"> {{Details.author}} </span>
            <span v-else> 暂无数据 </span>
          </span>
          <span>就诊科室：{{Details.cate_id_text}}</span>
        </p>
        <div
          class="rich-text ql-editor "
          v-html="Details.detail"
        ></div>
      </div>
    </el-card>
  </div>
</template> 

<script>
export default {
  name: 'editorProject',
  data () {
    return {
      Details: {}
    }
  },
  created () {
    this.compileEntry(this.$route.query.id)
  },
  methods: {
    //返回
    backProject () {
      this.$router.back()
    },
    //获取详情
    async compileEntry (id) {
      const { data: data } = await this.$http.post("bl/detail", {
        id
      })
      this.Details = data.data
    },
  }
}
</script>
 
 
<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .box-card {
    width: 100%;
    // flex: 1;
    min-height: 685px;
    overflow-y: auto;
    // margin-bottom: 40px;

    .content {
      h4 {
        font-size: 16px;
        color: #212529;
        text-align: center;
      }
      .p {
        margin-top: 20px;
        margin-bottom: 45px;
        color: #a8a8a8;
        font-size: 13px;
        text-align: center;
      }
    }
  }

  .rich-text {
    width: 100%;
    padding: 0 37px;
    // display: flex;
    // flex-wrap: wrap;
    // overflow: hidden;
    // background-color: pink !important;
  }
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
    background: #ccc;
  }
  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
    border-radius: 10px;
    background: #fff;
  }
}
</style>
